export default "__VITE_ASSET__BCInOuCt__"